<template>
  <div class="search-popup">
    <van-overlay :show="show">
      <div class="wrapper">
        <van-loading type="spinner" color="#1989fa" vertical>
          加载中...
        </van-loading>
      </div>
    </van-overlay>
    <van-empty v-if="lodError" image="network" description="您请求的数据暂时无法显示，请稍后再试" />
    <showpdf v-if="showPdf" @close='closePdf()' :url="pdfFile" :isClose="false"></showpdf>
  </div>
</template>
<script>
import { checkRegister, getPdfPreview } from '@/api/index'
import { geturl } from '@/utils/index';
import showpdf from './pdf/index'
export default {
  name: 'Transfer',
  components: {
    showpdf
  },
  data() {
    return {
      showPdf: false,
      pdfFile: "",
      show: false,
      lodError: false
    }
  },
  created() {
    let params = geturl();
    // const id = 'oEqTa6UrfBsR5xtBIgQv1MRaHikI'
    if (params && params.openId) {
      this.register(params.openId)
    }
    this.register('oEqTa6T8rmxXXaVv-tS2oihOqMUI')
  },
  mounted() {

  },
  methods: {
    register(val) {
      let params = {
        openId: val
      }
      checkRegister(params).then(res => {
        if (res) {
          this.getPdf()
        } else {
          this.$router.push(`/signup?openId=${val}`)
        }
      })
    },
    getPdf() {
      let params = {
        wechatDocumentId: localStorage.getItem('wechatDocumentId')
        // wechatDocumentId: 'a1ac77edf1c34689b72311154797d6f3'
      }
      this.show = true
      getPdfPreview(params).then(res => {
        if (res) {
          this.pdfFile = res
          this.showPdf = true
          this.show = false
        }
      }).catch(err => {
        this.show = false
        this.lodError = true
        console.log(err)
      })
    },
    closePdf() {
      this.showPdf = false
    },
  }
}
</script>
<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>